import React from "react";
import get from "lodash/get";
import ManagerProfilePage from "../../manager/ManagerProfilePage";

export function ManagerPage(props) {
    const data = get(props, ["data"], {});
    const { manager, adId, isMember } = data;

    if (!manager) {
        return (
            <div style={{ textAlign: "center", padding: "60px 20px" }}>
                <h2>Manager Not Found</h2>
            </div>
        );
    }

    return (
        <div className="custom-page-root">
            <ManagerProfilePage manager={manager} adId={adId} initialIsMember={isMember} />
        </div>
    );
}

export default ManagerPage;
